<template>
  <v-card>
    <v-card-text>
      <v-alert
        :value="errorInForm"
        icon="warning"
        type="error"
        outline
      >Reden moet gevuld zijn</v-alert>
      <v-textarea v-model="reason" :label="labelText()" @blur="validate"></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="cancel">Annuleren</v-btn>
      <v-btn color="primary" @click="clicked">Opslaan</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
import { visitService } from "@/services/address";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AssignmentCancelForm",
  props: ["status"],
  mixins: [validationMixin],
  validations: {
    radio: required
  },
  data() {
    return {
      reason: "",
      errorInForm: false,
      submitAttempt: false
    };
  },
  computed: {
    statuses() {
      return visitService.resolveStatuses();
    }
  },
  methods: {
    ...mapActions(["saveCancelLog"]),
    labelText() {
      return visitService.isOtherState(this.status) ? "Reden" : "Reden (verplicht veld)";
    },
    validate() {
      if (!this.submitAttempt) {
        return;
      }
      if (visitService.isOtherState(this.status)) {
        this.errorInForm = false;
        return;
      }
      if (this.reason && this.reason.length > 5) {
        this.errorInForm = false;
      } else {
        this.errorInForm = true;
      }
    },
    cancel() {
      this.$parent.closeWithoutSave();
    },
    clicked() {
      this.submitAttempt = true;
      this.validate();
      if (!this.errorInForm) {
        this.saveCancelLog({
          "status": this.status,
          "remark": this.reason
        });
        this.$parent.cancelVisit();
      }
    }
  }
};
</script>